import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import LegalUsersBox from '../../LegalUsersBox/index';
import HeaderSection from '../HeaderSection/HeaderSection';
import * as ROUTES from '../../../routes';
import './LawyersFirms.scss';

const LawyersFirms = ({ location, landingLawyers, landingLawfirms }) => {
  
  const [stateOfRepublic, setStateOfRepublic] = useState('')

  useEffect(() => {
    const stateOfCountry = localStorage.getItem('stateOfCountry')
    setStateOfRepublic(stateOfCountry)
  }, [location, stateOfRepublic]);

  return (
    <div className="lawyersFirms" id="abogados-top">
      <div className="lawyersFirms_header">
        <HeaderSection
          title="Abogados y despachos Premium"
          subtitle="Encuentra a los mejores abogados y despachos de México en un solo lugar."
        />
      </div>
      {landingLawyers &&
      landingLawyers.length &&
      landingLawyers.length > 0 &&
      landingLawfirms &&
      landingLawfirms.length &&
      landingLawfirms.length > 0 ? (
        <div className="lawyersFirms_content">
          <div className="lawyersFirms_content_lawyers">
            <LegalUsersBox
              title="Abogados Premium"
              list={landingLawyers}
              buttonTitle={
                stateOfRepublic ?
                `Ver todos los abogados en ${stateOfRepublic}` :
                `Ver todos los abogados`
              }
              direction={
                stateOfRepublic ?
                `${ROUTES.SEARCH_LAWYER}estado/${stateOfRepublic}` :
                `${ROUTES.SEARCH_LAWYER}Abogados`
              }
              typeOfUser='lawyer'
            />
          </div>
          <LegalUsersBox
            title="Despachos Premium"
            list={landingLawfirms}
            buttonTitle={
              stateOfRepublic ?
              `Ver todos los despachos en ${stateOfRepublic}` :
              `Ver todos los despachos`
            }
            direction={
              stateOfRepublic ?
              `${ROUTES.SEARCH_LAWYER}estado/${stateOfRepublic}` :
              `${ROUTES.SEARCH_LAWYER}Despachos`
            }
            typeOfUser='lawFirm'
          />
        </div>
      ) : null}
    </div>
  );
}

const mapStateToProps = state => ({
  location: state.userState.browserLocation,
  landingLawyers: state.userState.landingLawyers,
  landingLawfirms: state.userState.landingLawfirms,
})

export default connect(mapStateToProps)(LawyersFirms);
